module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Code-b58b55d4228e2612505d93dc1f7d0f93.svg";